import React from "react";
import {
    TextField as BaseTextField,
    Input,
    Label,
    Text,
    TextArea,
    TextFieldProps,
    composeRenderProps,
} from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { RichText } from "../RichText";
import { FieldError, FieldProps } from "./common";

import styles from "./inputs.module.scss";

export function TextField({
    label,
    description,
    errorMessage,
    className,
    children,
    isMultiLine,
    ...props
}: FieldProps & TextFieldProps & { isMultiLine?: boolean }) {
    return (
        <BaseTextField
            {...props}
            className={composeRenderProps(className, (className) =>
                concatClassNames([styles.textField, className]),
            )}
            isInvalid={errorMessage ? true : undefined}
        >
            {composeRenderProps(children, (children) => (
                <>
                    {description && (
                        <Text slot="description">
                            <RichText value={description} />
                        </Text>
                    )}
                    <div className={styles.textFieldWrapper}>
                        <Label className={styles.textFieldLabel}>{label}</Label>
                        {isMultiLine ? <TextArea /> : <Input />}
                        {children && (
                            <div className={styles.childWrapper}>
                                {children}
                            </div>
                        )}
                    </div>
                    <FieldError>{errorMessage}</FieldError>
                </>
            ))}
        </BaseTextField>
    );
}
